/* global document, confirm */
import Cropper from 'cropperjs';
import $ from 'jquery';

const cropperTitles = {
	portraitSmall: 'Thumbnail',
	portraitBig: 'Portrait',
	figure: 'Figure',
	figureVertical: 'Figure (crop for PDF presentation)',
	additionalOne: 'First additional image',
	additionalTwo: 'Second additional image',
	additionalThree: 'Third additional image',
};

const aspectRatios = {
	portraitSmall: 100 / 50,
	portraitBig: 446 / 594,
	figure: 420 / 276,
	figureVertical: 446 / 594,
	additionalOne: 420 / 276,
	additionalTwo: 420 / 276,
	additionalThree: 420 / 276,
};


function createCropper(element, type) {
	return new Cropper(element, {
		aspectRatio: aspectRatios[type] || 1,
		viewMode: 1,
		zoomOnTouch: false,
		zoomOnWheel: false,
		minContainerWidth: 480,
		minCanvasWidth: 480,
		minContainerHeight: 388,
		minCanvasHeight: 388,
	});
}


function initCropper(cropper, extraId, image, type, secondaryType = null) {
	const secondary = secondaryType !== null;
	let activeCropper = null;
	let isChanged = false;

	const onChange = () => {
		isChanged = true;
	};

	const showModal = () => {
		cropper.closest('.modal').modal({
			backdrop: 'static',
		}).modal('show');
	};

	const primaryImage = cropper.find('.js-cropper-tab-content.js-cropper-primary .js-cropper-image');
	const secondaryImage = secondary ? cropper.find('.js-cropper-tab-content.js-cropper-secondary .js-cropper-image') : null;
	primaryImage.on('ready', showModal);

	cropper.find('.js-cropper-title').text(cropperTitles[type] || '');
	cropper.find('.js-cropper-head').toggle(secondary);
	cropper.find('.js-cropper-image').attr('src', image);
	cropper.find('.js-cropper-primary').addClass('active');
	cropper.find('[name="extraId"]').val(extraId);
	cropper.find('[name="type"]').val(type);

	const primaryCropper = createCropper(primaryImage[0], type);
	primaryImage.on('cropstart', onChange);
	activeCropper = primaryCropper;

	const secondaryCropper = secondary ? createCropper(secondaryImage[0], secondaryType) : null;
	if (secondary) {
		secondaryImage.on('cropstart', onChange);
	}


	const changeTab = (e) => {
		e.preventDefault();
		if (isChanged) {
			// eslint-disable-next-line no-restricted-globals, no-alert
			if (confirm('You have unsaved changes. If you continue, your changes will be lost.')) {
				primaryCropper.reset();
				if (secondary) {
					secondaryCropper.reset();
				}
				isChanged = false;
			} else {
				return;
			}
		}

		const primary = !secondary || $(e.currentTarget).is('.js-cropper-primary');
		const targetType = primary ? type : secondaryType;

		cropper.find('.js-cropper-title').text(cropperTitles[targetType] || '');
		cropper.find('.js-cropper-primary').toggleClass('active', primary);
		cropper.find('.js-cropper-secondary').toggleClass('active', !primary);
		cropper.find('[name="type"]').val(targetType);
		activeCropper = primary ? primaryCropper : secondaryCropper;
	};

	const sendForm = (e) => {
		e.preventDefault();
		e.stopPropagation();

		if (activeCropper === null) {
			return;
		}

		const sendingCropper = activeCropper;
		activeCropper = null;

		cropper.find('.js-crop-loader').addClass('is-visible');
		cropper.find('[name="imageData"]').val(sendingCropper.getCroppedCanvas({ fillColor: '#fff' }).toDataURL('image/jpeg'));

		$.nette.ajax({
			type: 'POST',
			url: cropper.attr('action'),
			data: cropper.serialize(),
			success: () => {
				cropper.closest('.modal').modal('hide');
				cropper.find('.js-crop-loader').removeClass('is-visible');
			},
		});
	};

	cropper.find('.js-cropper-tab-trigger').on('click', changeTab);
	cropper.find('.js-cropper-submit').on('click', sendForm);


	cropper.closest('.modal').one('hidden.bs.modal', () => {
		activeCropper = null;
		isChanged = false;

		cropper.find('.js-cropper-title').text('');
		cropper.find('.js-cropper-head').show();
		cropper.find('.js-cropper-image').attr('src', '');
		cropper.find('.js-cropper-tab-trigger').off('click', changeTab);
		cropper.find('.js-cropper-tab-trigger').removeClass('active');
		cropper.find('.js-cropper-tab-content').removeClass('active');
		cropper.find('[name="extraId"]').val('');
		cropper.find('[name="type"]').val('');
		cropper.find('[name="imageData"]').val('');

		primaryCropper.destroy();
		primaryImage.off('ready', showModal);
		primaryImage.off('cropstart', onChange);
		if (secondary) {
			secondaryCropper.destroy();
			secondaryImage.off('cropstart', onChange);
		}

		cropper.find('.js-cropper-submit').off('click', sendForm);
	});
}


$(document).on('click', '.js-cropper', (e) => {
	const { target } = e;
	e.preventDefault();

	initCropper(
		$('.js-cropper-modal').first(),
		$(target).data('extraId'),
		$(target).data('image'),
		$(target).data('type'),
		$(target).data('typeSecondary') || null,
	);
});



// WEBPACK FOOTER //
// ./frontend/js/cropper.js